export const aspects = [
  {
    name: '1:1',
    x: 1024,
    y: 1024,
  },
  {
    name: '1:2',
    x: 768,
    y: 1536,
  },
  {
    name: '2:1',
    x: 1536,
    y: 768,
  },
  {
    name: '3:4',
    x: 880,
    y: 1176,
  },
  {
    name: '9:16',
    x: 768,
    y: 1360,
  },
  {
    name: '3:2',
    x: 1248,
    y: 832,
  },
  {
    name: '4:3',
    x: 1176,
    y: 888,
  },
  {
    name: '16:9',
    x: 1360,
    y: 768,
  },
];
